import { render, staticRenderFns } from "./LpUpperRegionDropDown.vue?vue&type=template&id=248b0551&scoped=true"
import script from "./LpUpperRegionDropDown.vue?vue&type=script&lang=js"
export * from "./LpUpperRegionDropDown.vue?vue&type=script&lang=js"
import style0 from "./LpUpperRegionDropDown.vue?vue&type=style&index=0&id=248b0551&prod&lang=css"
import style1 from "./LpUpperRegionDropDown.vue?vue&type=style&index=1&id=248b0551&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b0551",
  null
  
)

export default component.exports